import React from 'react';
import { Dialog } from '@mui/material';
import styled from 'styled-components';

const StyledDialog = styled(Dialog)`
  && .MuiDialog-paperWidthSm {
    width: 100%;
    margin: 0;
    position: fixed;
    bottom: 0;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  @media (min-width: 600px) {
    && .MuiDialog-paperWidthSm {
      position: relative;
      max-width: 440px;
      border-radius: 12px;
    }
  }
`;

const CustomDialog = (props) => {
  const { children, isOpen, handleOnClose } = props;
  return (
    <StyledDialog aria-labelledby="dialog-title" open={isOpen} onClose={handleOnClose}>
      {children}
    </StyledDialog>
  );
};

export default CustomDialog;
